import { Injectable } from "@angular/core";
import { PublicHttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class PublicStatementsService {
  constructor(private http: PublicHttpClientService) {}

  public getStatementAccounts(app_id: number): Observable<any> {
    return this.http
      .get(`/api/public/applications/${app_id}/statements/accounts`)
      .pipe(tap((_) => console.log("PublicStatementsService.getStatementAccounts: Ok")));
  }
}
